document.addEventListener('DOMContentLoaded', () => {
  const headerMenu = document.querySelector('header-menu');
  if (!headerMenu) return;

  const overflowMenuRef = headerMenu.refs?.overflowMenu ?? headerMenu.querySelector('[ref="overflowMenu"]');
  if (!overflowMenuRef) return;

  const shadowOverflow = overflowMenuRef.shadowRoot?.querySelector('[part="overflow"]');
  if (!shadowOverflow) return;

  let deactivateTimer;

  shadowOverflow.addEventListener('pointerleave', (e) => {
    e.stopImmediatePropagation();
    deactivateTimer = setTimeout(() => {
      const isHovered =
        overflowMenuRef.shadowRoot?.querySelector('[part="overflow"]')?.matches(':hover') ||
        overflowMenuRef.shadowRoot?.querySelector('[part="overflow-list"]')?.matches(':hover');
      if (!isHovered) {
        shadowOverflow.dispatchEvent(new PointerEvent('pointerleave', { bubbles: false, cancelable: false }));
      }
    }, 2000);
  }, true);

  shadowOverflow.addEventListener('pointerenter', () => {
    clearTimeout(deactivateTimer);
  });
});